import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.object.values.js";
moment.locale("ja");
var __default__ = {
  name: "AttendanceIndex",
  data: function data() {
    return {
      fiscalYear: moment().add(-3, "month").year(),
      filterStatus: {
        type: "",
        classroom: ""
      },
      date: moment().format("YYYY-MM-DD"),
      formattedDate: moment().format("YYYY年MM月DD日(ddd)"),
      showModal: false,
      attendances: [],
      filteredAttendances: [],
      detail: {},
      byClassrooms: [],
      isLoading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["studentAddress", "school"])), {}, {
    currentYM: function currentYM() {
      return moment(this.date).format("YYYY-MM");
    }
  }),
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (moment(_this.$route.query.date, "YYYY-MM-DD", true).isValid()) {
                _this.date = _this.$route.query.date;
              }

              if (_this.$route.query.keyword) {
                _this.filterStatus.keyword = _this.$route.query.keyword;
              }

              if (_this.$route.query.type) {
                _this.filterStatus.type = _this.$route.query.type;
              }

              if (_this.$route.query.classroom_id && _this.classrooms.find(function (v) {
                return Number(v.id) === Number(_this.$route.query.classroom_id);
              })) {
                _this.filterStatus.classroom = _this.$route.query.classroom_id;
              }

              _context.next = 6;
              return _this.getAttendance();

            case 6:
              _this.isLoading = false;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    iconColor: iconColor,
    getAttendance: function getAttendance() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, _data, attendances, keyword, classroom, type, attendances1, attendances2;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.formattedDate = moment(_this2.date).format("YYYY年MM月DD日(ddd)");

                if (!_this2.schoolPlan.temperature) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 4;
                return getData(["attendances?date=" + _this2.date + "&orderby=created_at&with=student.classroom&show_daily_all=1", "temperatures?date=".concat(_this2.date)]).catch(function (error) {
                  console.log(error);
                  return null;
                });

              case 4:
                data = _context2.sent;

                if (data) {
                  _context2.next = 8;
                  break;
                }

                _this2.isLoading = false;
                return _context2.abrupt("return");

              case 8:
                _this2.temperatureCount = data[1].items.count;
                _this2.attendances = data[0].items;
                _context2.next = 19;
                break;

              case 12:
                _context2.next = 14;
                return getData(["attendances?date=" + _this2.date + "&orderby=created_at&with=student.classroom&show_daily_all=1"]).catch(function (error) {
                  console.log(error);
                  return null;
                });

              case 14:
                _data = _context2.sent;

                if (_data) {
                  _context2.next = 18;
                  break;
                }

                _this2.isLoading = false;
                return _context2.abrupt("return");

              case 18:
                _this2.attendances = _data[0].items;

              case 19:
                attendances = _this2.attendances;
                keyword = _this2.filterStatus.keyword;
                classroom = Number(_this2.filterStatus.classroom);
                type = _this2.filterStatus.type;

                if (keyword) {
                  attendances = attendances.filter(function (v) {
                    return Object.keys(v).some(function (k) {
                      return String(v[k]).indexOf(keyword) > -1;
                    });
                  });
                }

                if (type) {
                  if (type === "登下校") {
                    attendances1 = attendances.filter(function (v) {
                      return Object.keys(v).some(function (k) {
                        return String(v[k]).indexOf("登校") > -1;
                      });
                    });
                    attendances2 = attendances.filter(function (v) {
                      return Object.keys(v).some(function (k) {
                        return String(v[k]).indexOf("下校") > -1;
                      });
                    });
                    attendances = attendances1.concat(attendances2);
                  } else {
                    attendances = attendances.filter(function (v) {
                      return v.type.indexOf(type) > -1;
                    });
                  }
                }

                if (classroom) {
                  attendances = attendances.filter(function (v) {
                    return v.student && v.student.class_id === classroom;
                  }); //クラス検索のときはそのクラスだけ表示だけする

                  _this2.byClassrooms = [{
                    attendances: [],
                    classroom: _this2.classrooms.find(function (v) {
                      return v.id === classroom;
                    })
                  }];
                } else {
                  _this2.byClassrooms = [];

                  _this2.classrooms.forEach(function (v) {
                    _this2.byClassrooms.push({
                      attendances: [],
                      classroom: v
                    });
                  });
                }

                attendances.sort(function (a, b) {
                  if (a.student_id !== b.student_id) {
                    if (a.student.ruby > b.student.ruby) {
                      return 1;
                    }

                    if (a.student.ruby < b.student.ruby) {
                      return -1;
                    }
                  }

                  var aDate = moment(a.created_at);
                  var bDate = moment(b.created_at);

                  if (aDate.isBefore(bDate)) {
                    return 1;
                  }

                  if (bDate.isBefore(aDate)) {
                    return -1;
                  }

                  return 0;
                });
                _this2.attendances = _this2.filteredAttendances = attendances.map(function (v) {
                  return {
                    id: v.id,
                    student_id: v.student_id,
                    student: v.student,
                    date: moment(v.date).format("YYYY年MM月DD日(ddd)"),
                    name: v.name,
                    comment: v.comment,
                    guardian_memo: v.guardian_memo,
                    type: v.type,
                    typeText: Text.attendances.type[v.type],
                    created_at: v.created_at,
                    classrooms_id: v.student && v.student.classroom ? v.student.classroom.id : null,
                    classrooms_name: v.student && v.student.classroom ? v.student.classroom.name : null,
                    is_daily_latest: v.is_daily_latest
                  };
                });

                _this2.filteredAttendances.forEach(function (v) {
                  _this2.byClassrooms.forEach(function (v2) {
                    if (v2.classroom.id === v.classrooms_id) {
                      v2.attendances.push(v);
                    }
                  });
                });

                _this2.isLoading = false;

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    filterAttendances: function filterAttendances() {
      var query = moment().isSame(this.date, "day") ? {} : {
        date: this.date
      };
      if (this.filterStatus.keyword) query["keyword"] = this.filterStatus.keyword;
      if (this.filterStatus.classroom) query["classroom_id"] = this.filterStatus.classroom;
      if (this.filterStatus.type) query["type"] = this.filterStatus.type;
      this.$router.push({
        query: query
      });
      this.getAttendance();
    },
    calcAttendance: function calcAttendance(list, type) {
      switch (type) {
        case "absent":
          return list.filter(function (v) {
            return v.is_daily_latest && v.type.indexOf("欠席") > -1;
          }).length;

        case "late":
          return list.filter(function (v) {
            return v.is_daily_latest && v.type.indexOf("遅刻") > -1;
          }).length;

        case "leave":
          return list.filter(function (v) {
            return v.is_daily_latest && v.type.indexOf("早退") > -1;
          }).length;

        case "not_attend":
          return list.filter(function (v) {
            return v.is_daily_latest && v.type.indexOf("未登校") > -1;
          }).length;

        case "way":
          return list.filter(function (v) {
            return v.type.split("-")[0] === "登校" || v.type.split("-")[0] === "下校";
          }).length;
      }
    },
    downloadCSV: function downloadCSV() {
      var csvArray = [["No", "クラス", this.studentAddress + "氏名", "連絡区分", "欠席理由", "保護者メモ", "先生メモ"]];
      this.attendances.filter(function (v) {
        return v.is_daily_latest;
      }).forEach(function (v, i) {
        var row = [i + 1, v.classrooms_name, v.student.name, v.type.split("-").shift(), v.type, v.guardian_memo, v.comment];
        csvArray.push(row);
      });
      var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      saveAs(new Blob([bom, Papa.unparse(csvArray)], {
        type: "text/csv;charset=utf-8"
      }), this.formattedDate + "_出欠席状況.csv");
    }
  }
};
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useAbsentAlertStore } from "@/stores/absentAlert";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import AbsentAlertList from "@/components/attendances/AbsentAlertList.vue";
import moment from "moment";
import Text from "@/consts/text";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { iconColor } from "@/consts/iconColor";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var absentAlertStore = useAbsentAlertStore();

    var _storeToRefs = storeToRefs(absentAlertStore),
        absentcontinuouslyObj = _storeToRefs.absentcontinuouslyObj,
        absentFrequentlyObj = _storeToRefs.absentFrequentlyObj;

    var _storeToRefs2 = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs2.classrooms,
        totalStudentCount = _storeToRefs2.totalStudentCount;

    var _storeToRefs3 = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs3.schoolPlan;

    var temperatureCount = ref({});
    var totalTemperatureCount = computed(function () {
      return Object.values(temperatureCount.value).reduce(function (sum, current) {
        return sum + current;
      }, 0);
    }); // created

    absentAlertStore.getAbsentAlert();
    expose({
      classrooms: classrooms,
      temperatureCount: temperatureCount,
      schoolPlan: schoolPlan
    });
    return {
      __sfc: true,
      absentAlertStore: absentAlertStore,
      absentcontinuouslyObj: absentcontinuouslyObj,
      absentFrequentlyObj: absentFrequentlyObj,
      classrooms: classrooms,
      totalStudentCount: totalStudentCount,
      schoolPlan: schoolPlan,
      temperatureCount: temperatureCount,
      totalTemperatureCount: totalTemperatureCount,
      AbsentAlertList: AbsentAlertList,
      RowItem: RowItem,
      iconColor: iconColor
    };
  }
});